module.exports = __webpack_public_path__ + "088bbeb7f9ab52ddf49717edf596d439.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/plate-colorpicker/img/metal-color-redgold-brushed.png
// module id = D9tF
// module chunks = 5